// Costanti della landing "Trilocale Via Paternò 12" — modificare qui, non nei componenti.

// true = trilocale VENDUTO (landing in versione "venduto", badge sulla scheda Sixt12). false = torna la versione promo.
export const TRILOCALE_VENDUTO = true;
// La scheda operazione che mostra il badge "Trilocale: VENDUTO" viene riconosciuta dal titolo (funziona anche sul live con id diverso).
export const SIXT12_TITLE_MATCH = /sixt12/i;

export const WHATSAPP_NUMBER = "393331160150";
export const WHATSAPP_DISPLAY = "+39 333 1160150";
export const WHATSAPP_MESSAGE = "Buongiorno, vorrei informazioni sul trilocale di Via Paternò 12 (promo 269.000 €)";
export const WHATSAPP_MESSAGE_VENDUTO = "Buongiorno, ho visto che il trilocale di Via Paternò 12 è venduto: avete altre soluzioni disponibili?";
export const WHATSAPP_URL = `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(TRILOCALE_VENDUTO ? WHATSAPP_MESSAGE_VENDUTO : WHATSAPP_MESSAGE)}`;

export const CLASSE_ENERGETICA = "B";

export const PREZZO_LISTINO = 275000;
export const PREZZO_PROMO = 269000;
export const PROMO_DEADLINE = "2026-10-23T23:59:00+02:00"; // ora di Milano
export const PROMO_DEADLINE_LABEL = "23/10/2026";

// ID Meta Pixel / Google Tag: vedi src/config/tracking.js

export const LANDING_PATH = "/trilocale-paterno-12";

export const PHOTOS = [
  { src: "/trilocale/01_soggiorno.jpg", thumb: "/trilocale/01_soggiorno_thumb.jpg", alt: "Soggiorno arredato del trilocale" },
  { src: "/trilocale/02_soggiorno_cucina.jpg", thumb: "/trilocale/02_soggiorno_cucina_thumb.jpg", alt: "Soggiorno con cucina arredata" },
  { src: "/trilocale/03_cucina_pranzo.jpg", thumb: "/trilocale/03_cucina_pranzo_thumb.jpg", alt: "Cucina e zona pranzo" },
  { src: "/trilocale/05_divano.jpg", thumb: "/trilocale/05_divano_thumb.jpg", alt: "Zona divano del soggiorno" },
  { src: "/trilocale/06_camera_matrimoniale.jpg", thumb: "/trilocale/06_camera_matrimoniale_thumb.jpg", alt: "Camera matrimoniale" },
  { src: "/trilocale/07_camera_armadio_clima.jpg", thumb: "/trilocale/07_camera_armadio_clima_thumb.jpg", alt: "Camera con armadio e climatizzatore" },
  { src: "/trilocale/08_seconda_camera.jpg", thumb: "/trilocale/08_seconda_camera_thumb.jpg", alt: "Seconda camera" },
  { src: "/trilocale/09_bagno.jpg", thumb: "/trilocale/09_bagno_thumb.jpg", alt: "Bagno" },
];
export const HERO_PHOTO = PHOTOS[0];
export const PLANIMETRIA = { src: "/trilocale/planimetria.jpg", alt: "Planimetria di progetto del trilocale (perimetro verde)" };

export const formatPrice = (n) => `€${String(Math.round(n)).replace(/\B(?=(\d{3})+(?!\d))/g, ".")}`;
